import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import * as fromRoot from '../../state';
import * as rootActions from '../../state/app.actions';
import {
  GC_AUTH_TOKEN,
  GC_EXPIRE,
  GC_EXPIRE_7DAYS,
  GC_LIVE_TOKEN
} from '../../constants';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor(
    private apollo: Apollo,
    private store$: Store<fromRoot.State>,
    private router: Router
  ) {}

  saveTokenData(token: string, expire: string, live: boolean): void {
    // delete cookies 1st before saving

    localStorage.setItem(GC_EXPIRE, expire);
    localStorage.setItem(
      GC_EXPIRE_7DAYS,
      moment(expire)
        .add(7, 'days')
        .toString()
    );
    /**
     * will expire in 1 week hence wont be found
     * */
    localStorage.setItem(GC_AUTH_TOKEN, token);
    localStorage.setItem(GC_LIVE_TOKEN, String(live));
  }

  logout(): void {
    // clear current user
    this.store$.dispatch(new rootActions.ClearSessionLogin());

    // Removing user data from local storage and the service
    this.clearSession();

    // reset the cached data
    this.apollo.getClient().resetStore();

    // navigate to login
    this.router.navigate(['/auth/login']);
  }

  // check if token should to be refreshed
  // if is older than 1hr
  shouldRefreshToken(): boolean {
    const tokenTime = localStorage.getItem(GC_EXPIRE);
    const localTime = moment.utc(tokenTime).local();

    const difference = localTime.diff(moment(), 'minutes');
    return difference < 0;
  }

  getToken(): string {
    const expire = localStorage.getItem(GC_EXPIRE_7DAYS);
    const dirtyToken = localStorage.getItem(GC_AUTH_TOKEN);

    if (expire) {
      const expireDays = moment
        .utc(expire)
        .local()
        .diff(moment(), 'days');

      if (!dirtyToken || expireDays < 1) {
        this.clearSession();
        this.store$.dispatch(new rootActions.Authenticate(false));
      } else {
        this.store$.dispatch(new rootActions.Authenticate(true));
      }
    }

    return localStorage.getItem(GC_AUTH_TOKEN);
  }

  isTokenLive(): boolean {
    const live = localStorage.getItem(GC_LIVE_TOKEN);
    return /true/i.test(live);
  }

  clearSession(): void {
    localStorage.removeItem(GC_EXPIRE);
    localStorage.removeItem(GC_LIVE_TOKEN);
    localStorage.removeItem(GC_AUTH_TOKEN);
  }
}
